export default "__VITE_ASSET__a285d564__"